module.exports = " <div> <div v-if=loading class=\"loading loading-basic\"> <span class=\"icon icon-circular-graph animation-spin\"></span> {{ translate('cp.loading') }} </div> <div class=user_roles-fieldtype v-if=!loading> <relate-fieldtype :data.sync=data :name=name :config=config :suggestions-prop=roles :disabled=!canEdit v-ref:relate> </relate-fieldtype> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/UserRolesFieldtype.vue
// module id = 781
// module chunks = 0